import { render, staticRenderFns } from "./LocalAuthority.vue?vue&type=template&id=c3419cfa&"
import script from "./LocalAuthority.vue?vue&type=script&lang=js&"
export * from "./LocalAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports